(function () {
  const SCROLL_OFFSET = 80;

  function initFeaturedGallery(root) {
    if (root.dataset.featuredGalleryInit === 'true') return;
    root.dataset.featuredGalleryInit = 'true';

    const slides = Array.from(root.querySelectorAll('.collection-plp-featured-gallery__slide'));
    const thumbs = Array.from(root.querySelectorAll('.collection-plp-featured-gallery__thumb'));
    const track = root.querySelector('[data-thumbs-track]');
    const prevBtn = root.querySelector('[data-thumbs-prev]');
    const nextBtn = root.querySelector('[data-thumbs-next]');

    if (!slides.length) return;

    const setActiveSlide = (index) => {
      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === index;
        slide.classList.toggle('is-active', isActive);
        slide.hidden = !isActive;
      });

      thumbs.forEach((thumb, thumbIndex) => {
        const isActive = thumbIndex === index;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
        if (isActive) {
          thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }
      });
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const index = Number(thumb.dataset.mediaIndex);
        if (!Number.isNaN(index)) setActiveSlide(index);
      });
    });

    if (track && prevBtn && nextBtn) {
      prevBtn.addEventListener('click', () => {
        track.scrollBy({ left: -SCROLL_OFFSET, behavior: 'smooth' });
      });

      nextBtn.addEventListener('click', () => {
        track.scrollBy({ left: SCROLL_OFFSET, behavior: 'smooth' });
      });
    }
  }

  const boot = () => {
    document.querySelectorAll('[data-featured-gallery]').forEach(initFeaturedGallery);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
